const ptsd_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "maxLength":950,
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_3[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].Page_3[0].IdentifyEvidence[0]",
      "textanswer":""
   },   
   {
      "question":"Relevant Social/Marital/Family History",
      "sub":"Please complete the following sections by asking the Veteran how the symptoms of the mental condition(s) have affected him or her. Only include information about situations and/or events that occurred during or after the Veteran's active duty military service. It is important that situations and/or events prior to active duty service be excluded",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "CLINICAL FINDINGS",
         number: "2A"
      },
      "maxLength":340,
      "dbqName":"form1[0].Page_3[0].RecentHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Occupational  and Educational History",
      "sub":"Please complete the following sections by asking the Veteran how the symptoms of the mental condition(s) have affected him or her. Only include information about situations and/or events that occurred during or after the Veteran's active duty military service. It is important that situations and/or events prior to active duty service be excluded",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "CLINICAL FINDINGS",
         number: "2B"
      },
      "maxLength":340,
      "dbqName":"form1[0].Page_3[0].OccupationalandEducationalHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Mental Health History",
      "sub":"To include prescribed medications and family mental health",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "CLINICAL FINDINGS",
         number: "2C"
      },
      "maxLength": 260,
      "dbqName":"form1[0].Page_3[0].MentalhealthHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Legal and Behavioral History",
      "sub":"Please complete the following sections by asking the Veteran how the symptoms of the mental condition(s) have affected him or her. Only include information about situations and/or events that occurred during or after the Veteran's active duty military service. It is important that situations and/or events prior to active duty service be excluded",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "CLINICAL FINDINGS",
         number: "2D"
      },
      "maxLength": 260,
      "dbqName":"form1[0].Page_3[0].LegalandBehavioralHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Substance Abuse History",
      "sub":"Please complete the following sections by asking the Veteran how the symptoms of the mental condition(s) have affected him or her. Only include information about situations and/or events that occurred during or after the Veteran's active duty military service. It is important that situations and/or events prior to active duty service be excluded",
      "type":"textarea",
      "show": true,
      "section": {
         page: "4",
         title: "CLINICAL FINDINGS",
         number: "2E"
      },
      "maxLength": 750,
      "dbqName":"form1[0].Page_4[0].SubstanceAbuseHistory[0]",
      "answer":""
   },
   {
      "question":"PTSD Diagnostic Criteria-Criterion A",
      "sub":"Exposure to actual or threatened a) death, b) serious injury, c) sexual violation, in one or more of the following ways",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 2,
      "height": "auto",
      "section": {
         page: "4",
         title: "PTSD DIAGNOSTIC CRITERIA",
         number: "A"
      },
      "questions":[
         {
            "main":" Directly experiencing the traumatic event(s)",
            "dbqName":"form1[0].Page_4[0].CritA1[0]",
            "answer":""
         },
         {
            "main":"Witnessing, in person, the traumatic event(s) as they occurred to others",
            "dbqName":"form1[0].Page_4[0].CritA2[0]",
            "answer":""
         },
         {
            "main":"Learning that the traumatic event(s) occurred to a close family member or close friend; cases of actual or threatened death must have been violent or accidental; or, experiencing repeated or extreme exposure to aversive details of the traumatic event(s) (e.g., first responders collecting human remains; police officers repeatedly exposed to details of child abuse); this does not apply to exposure through electronic media, television, movies, or pictures, unless this exposure is work related",
            "dbqName":"form1[0].Page_4[0].CritA3[0]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"PTSD Diagnostic Criteria-Criterion B",
      "sub":"Presence of (one or more) of the following intrusion symptoms associated with the traumatic event(s), beginning after the traumatic event(s) occurred",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 2,
      "height": "auto",
      "section": {
         page: "4",
         title: "PTSD DIAGNOSTIC CRITERIA",
         number: "B"
      },
      "questions":[
         {
            "main":"Recurrent, involuntary, and intrusive distressing memories of the traumatic event(s)",
            "dbqName":"form1[0].Page_4[0].CritB1[0]",
            "answer":""
         },
         {
            "main":"Recurrent distressing dreams in which the content and/or affect of the dream are related to the traumatic event(s)",
            "dbqName":"form1[0].Page_4[0].CritB2[0]",
            "answer":""
         },
         {
            "main":"Dissociative reactions (e.g., flashbacks) in which the individual feels or acts as if the traumatic event(s) were recurring. (Such reactions may occur on a continuum, with the most extreme expression being a complete loss of awareness of present surroundings.)",
            "dbqName":"form1[0].Page_4[0].CritB3[0]",
            "answer":""
         },
         {
            "main":"Intense or prolonged psychological distress at exposure to internal or external cues that symbolize or resemble an aspect of the traumatic event(s)",
            "dbqName":"form1[0].Page_4[0].CritB4[0]",
            "answer":""
         },
         {
            "main":"Marked physiological reactions to internal or external cues that symbolize or resemble an aspect of the traumatic event(s)",
            "dbqName":"form1[0].Page_4[0].CritB5[0]",
            "answer":""
         }              
      ],
      "answer":""
   },
   {
      "question":"PTSD Diagnostic Criteria-Criterion C",
      "sub":"Persistent avoidance of stimuli associated with the event(s), beginning after traumatic event(s) occurred, as evidence of one or both of the following",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 2,
      "height": "auto",
      "section": {
         page: "4",
         title: "PTSD DIAGNOSTIC CRITERIA",
         number: "C"
      },
      "questions":[
               {
                  "main":"Avoidance of or efforts to avoid distressing memories, thoughts, or feelings about or closely associated with the traumatic event(s)",
                  "dbqName":"form1[0].Page_4[0].CritC1[0]",
                  "answer":""
               },
               {
                  "main":"Avoidance of or efforts to avoid external reminders (people, places, conversations, activities, objects, situations) that arouse distressing memories, thoughts, or feelings about or closely associated with the traumatic event(s)",
                  "dbqName":"form1[0].Page_4[0].CritC2[0]",
                  "answer":""
               }               
            ],
            "answer":""
   },
   {
      "question":"PTSD Diagnostic Criteria-Criterion D",
      "sub":"Negative alterations in cognitions and mood associated with the traumatic event(s), beginning or worsening after the traumatic event(s) occurred, as evidenced by two (or more) of the following",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 2,
      "minRequiredAns": 2,
      "height": "auto",
      "section": {
         page: "4",
         title: "PTSD DIAGNOSTIC CRITERIA",
         number: "D"
      },
      "questions":[
               {
                  "main":"Inability to remember an important aspect of the traumatic event(s) (typically due to dissociative amnesia and not to other factors such as head injury, alcohol, or drugs)",
                  "dbqName":"form1[0].Page_4[0].CritD1[0]",
                  "answer":""
               },
               {
                  "main":"Persistent and exaggerated negative beliefs or expectations about oneself, others, or the world (e.g., “I am bad,: “No one can be trusted,: “The world is completely dangerous,: “My whole nervous system is permanently ruined”)",
                  "dbqName":"form1[0].Page_4[0].CritD2[0]",
                  "answer":""
               },
               {
                  "main":"Persistent, distorted cognitions about the cause or consequences of the traumatic event(s) that lead to the individual to blame himself/herself or others",
                  "dbqName":"form1[0].Page_4[0].CritD3[0]",
                  "answer":""
               },
               {
                  "main":"Persistent negative emotional state (e.g., fear, horror, anger, guilt, or shame)",
                  "dbqName":"form1[0].Page_4[0].CritD4[0]",
                  "answer":""
               },
               {
                  "main":"Markedly diminished interest or participation in significant activities",
                  "dbqName":"form1[0].Page_4[0].CritD5[0]",
                  "answer":""
               },
               {
                  "main":"Feelings of detachment or estrangement from others",
                  "dbqName":"form1[0].Page_4[0].CritD6[0]",
                  "answer":""
               },
               {
                  "main":"Persistent inability to experience positive emotions (e.g., inability to experience happiness, satisfaction, or loving feelings.)",
                  "dbqName":"form1[0].Page_4[0].CritD6[1]",
                  "answer":""
               }             
            ],
            "answer":""
   },
   {
      "question":"PTSD Diagnostic Criteria-Criterion E",
      "sub":"Marked alterations in arousal and reactivity associated with the traumatic event(s), beginning or worsening after the traumatic event(s) occurred, as evidenced by two (or more) of the following:",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 2,
      "height": "auto",
      "section": {
         page: "5",
         title: "PTSD DIAGNOSTIC CRITERIA",
         number: "E"
      },
      "questions":[
               {
                  "main":"Irritable behavior and angry outbursts typically expressed as verbal or physical aggression toward people or objects",
                  "dbqName":"form1[0].Page_5[0].CritE1[0]",
                  "answer":""
               },
               {
                  "main":"Reckless or self-destructive behavior",
                  "dbqName":"form1[0].Page_5[0].CritE2[4]",
                  "answer":""
               },
               {
                  "main":"Hypervigilance",
                  "dbqName":"form1[0].Page_5[0].CritE3[0]",
                  "answer":""
               },
               {
                  "main":"Exaggerated startle response",
                  "dbqName":"form1[0].Page_5[0].CritE1[1]",
                  "answer":""
               },
               {
                  "main":"Problems with concentration",
                  "dbqName":"form1[0].Page_5[0].CritE2[5]",
                  "answer":""
               },
               {
                  "main":"Sleep disturbance (e.g., difficulty falling or staying asleep or restless sleep)",
                  "dbqName":"form1[0].Page_5[0].CritE3[1]",
                  "answer":""
               }    
            ],
            "answer":""
   },
   {
      "question":"Symptoms",
      "sub":"Please check all symptoms that apply to the Veteran's diagnosis(es):",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "cols": 4,
      "height":"auto",
      "section": {
         page: "5",
         title: "SYMPTOMS",
         number: "4"
      },
      "questions":[
               {
                  "main":"Depressed mood",
                  "dbqName":"form1[0].Page_5[0].LevelC1[0]",
                  "answer":""
               },
               {
                  "main":"Anxiety",
                  "dbqName":"form1[0].Page_5[0].LevelC2[0]",
                  "answer":""
               },
               {
                  "main":"Suspiciousness",
                  "dbqName":"form1[0].Page_5[0].LevelC3[0]",
                  "answer":""
               },
               {
                  "main":"Panic attacks, weekly or less often",
                  "dbqName":"form1[0].Page_5[0].LevelC4[0]",
                  "answer":""
               },
               {
                  "main":"Panic attacks more than once a week",
                  "dbqName":"form1[0].Page_5[0].LevelD3[0]",
                  "answer":""
               },
               {
                  "main":"Near-continuous panic and/or depression affecting the ability to function independently, appropriately, and effectively",
                  "dbqName":"form1[0].Page_5[0].LevelE4[0]",
                  "answer":""
               },
               {
                  "main":"Chronic sleep impairment, including nightmares",
                  "dbqName":"form1[0].Page_5[0].LevelC5[0]",
                  "answer":""
               },
               {
                  "main":"Mild memory loss such as forgetting names, forgetting directions, and forgetting recent events",
                  "dbqName":"form1[0].Page_5[0].LevelC6[0]",
                  "answer":""
               },
               {
                  "main":"Impairment of short and long-term memory such as retention of only highly learned material and forgetting to complete tasks",
                  "dbqName":"form1[0].Page_5[0].LevelD5[0]",
                  "answer":""
               },
               {
                  "main":"Memory loss for names of close relatives, own occupation, or own name",
                  "dbqName":"form1[0].Page_5[0].LevelF7[0]",
                  "answer":""
               },
               {
                  "main":"Flattened affect",
                  "dbqName":"form1[0].Page_5[0].LevelD1[0]",
                  "answer":""
               },
               {
                  "main":"Circumstantial, circumlocutory, or stereotyped speech",
                  "dbqName":"form1[0].Page_5[0].LevelD2[0]",
                  "answer":""
               },
               {
                  "main":"Speech intermittently illogical, obscure, or irrelevant",
                  "dbqName":"form1[0].Page_5[0].LevelE3[0]",
                  "answer":""
               },
               {
                  "main":"Difficulty in understanding complex commands",
                  "dbqName":"form1[0].Page_5[0].LevelD4[0]",
                  "answer":""
               },
               {
                  "main":"Impaired judgement",
                  "dbqName":"form1[0].Page_5[0].LevelD6[0]",
                  "answer":""
               },
               {
                  "main":"Impaired abstract thinking",
                  "dbqName":"form1[0].Page_5[0].LevelD7[0]",
                  "answer":""
               },
               {
                  "main":"Gross impairment in thought processes or communication",
                  "dbqName":"form1[0].Page_5[0].LevelF1[0]",
                  "answer":""
               },
               {
                  "main":"Disturbances of motivation and mood",
                  "dbqName":"form1[0].Page_5[0].LevelD8[0]",
                  "answer":""
               },
               {
                  "main":"Difficulty in establishing and maintaining effective work and/or social relationship",
                  "dbqName":"form1[0].Page_5[0].LevelD9[0]",
                  "answer":""
               },
               {
                  "main":"Difficulty adapting to stressful circumstances including work or a work-like setting",
                  "dbqName":"form1[0].Page_5[0].LevelE8[0]",
                  "answer":""
               },
               {
                  "main":"Inability to establish and maintain effective relationships",
                  "dbqName":"form1[0].Page_5[0].LevelE9[0]",
                  "answer":""
               },
               {
                  "main":"Suicidal ideation",
                  "dbqName":"form1[0].Page_5[0].LevelE1[0]",
                  "answer":""
               },
               {
                  "main":"Obsessional rituals which interfere with routine activities",
                  "dbqName":"form1[0].Page_5[0].LevelE2[0]",
                  "answer":""
               },
               {
                  "main":"Impaired impulse control such as unprovoked irritability with periods of violence",
                  "dbqName":"form1[0].Page_5[0].LevelE5[0]",
                  "answer":""
               },
               {
                  "main":"Spatial disorientation",
                  "dbqName":"form1[0].Page_5[0].LevelE6[0]",
                  "answer":""
               },
               {
                  "main":"Persistent delusions or hallucinations",
                  "dbqName":"form1[0].Page_5[0].LevelF2[0]",
                  "answer":""
               },
               {
                  "main":"Grossly inappropriate behavior",
                  "dbqName":"form1[0].Page_5[0].LevelF3[0]",
                  "answer":""
               },
               {
                  "main":"Persistent danger of hurting self or others",
                  "dbqName":"form1[0].Page_5[0].LevelF4[0]",
                  "answer":""
               },
               {
                  "main":"Neglect of personal appearance and hygiene",
                  "dbqName":"form1[0].Page_5[0].LevelE7[0]",
                  "answer":""
               },
               {
                  "main":"Intermittent ability to perform activities of daily living, including maintenance of minimal personal hygiene",
                  "dbqName":"form1[0].Page_5[0].LevelF5[0]",
                  "answer":""
               },
               {
                  "main":"Disorientation to time or place",
                  "dbqName":"form1[0].Page_5[0].LevelF6[0]",
                  "answer":""
               }           
            ],
            "answer":""
   },
   {
      "question":"Please describe behavior observations",
      "sub":"",
      "type":"textarea",
      "show": true,
      "section": {
         page: "6",
         title: "BEHAVIORAL OBSERVATIONS",
         number: "5"
      },
      "maxLength":775,
      "dbqName":"form1[0].Page_6[0].IfYesDescribe[3]",
      "answer":""
   },   
   {
      "question":"Does ##name## have any other symptoms attributable to PTSD (and other mental disorders) that are not listed in previous questions?",
      "sub":"",
      "type":"yesno",
      "show" : true,
      "section": {
         page: "6",
         title: "OTHER SYMPTOMS",
         number: "6"
      },
      "maxLength":600,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].Page_6[0].Yes3[0]",
      "dbqName_no":"form1[0].Page_6[0].No3[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "textdbqName":"form1[0].Page_6[0].IfYesDescribe[0]",
      "textanswer":""
   },
   {
      "question":"Occupational and Social Impairment",
      "sub":"Which of the following best summarizes the Veteran's level of occupational and social impairment with regards to the mental diagnosis? (Check only one)",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "cols": 2,
      "height": "auto",
      "section": {
         page: "2",
         title: "OCCUPATIONAL AND SOCIAL IMPAIRMENT",
         number: "4"
      },
      "questions":[
               {
                  "main":"Occupational and social impairment due to mild or transient symptoms which decrease work efficiency and ability to perform occupational tasks only during periods of significant stress, or symptoms controlled by medication.",
                  "dbqName":"form1[0].Page_2[0].Level[2]",
                  "answer":""
               },
               {
                  "main":"Occupational and social impairment with occasional decrease in work efficiency and intermittent periods of inability to perform occupational tasks, although generally functioning satisfactorily, with normal routine behavior, self-care, and conversation.",
                  "dbqName":"form1[0].Page_2[0].Level[3]",
                  "answer":""
               },
               {
                  "main":"Occupational and social impairment with reduced reliability and productivity.",
                  "dbqName":"form1[0].Page_2[0].Level[4]",
                  "answer":""
               },
               {
                  "main":"Occupational and social impairment with deficiencies in most areas, such as work, school, family relations, judgment, thinking, and/or mood.",
                  "dbqName":"form1[0].Page_2[0].Level[5]",
                  "answer":""
               },
               {
                  "main":"Total occupational and social impairment.",
                  "dbqName":"form1[0].Page_2[0].Level[6]",
                  "answer":""
               }            
            ],
            "answer":""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":350,
      "show": true,
      "section": {
         page: "6",
         title: "REMARKS",
         number: "8"
      },
      "options":[],
      "dbqName":"form1[0].Page_6[0].IfYesDescribe[2]",
      "answer":""
   }
 ]

 export default ptsd_questions ;
